import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchMinis, fetchMiniDownloadCSV, updateMini } from '../actions/minis'
import { fetchCustomers } from '../actions/customers'

import MiniList from '../components/MiniList'
import ErrorMessage from '../components/ErrorMessage'
import '../styles/MachinesAdminView.css'

class MinisView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {

    }

    this.handleMiniDownloadCSV = this.handleMiniDownloadCSV.bind(this)
    this.handleInlineSave = this.handleInlineSave.bind(this)
  }

  componentDidMount() {
    this.props.fetchMinis()

    if (this.props.role === 'ADMIN') {
      this.props.fetchCustomers()
    }
  }

  handleMiniDownloadCSV() {
    const { fetchMiniDownloadCSV } = this.props

    fetchMiniDownloadCSV();
  }

  handleInlineSave(Serial, props) {
    const { updateMini, fetchMinis, fullname } = this.props

    return updateMini(Serial, { ...props, Executor: fullname })
      .then(response => {
        if (!response.error) {
          fetchMinis()
        }

        return response
      })
  }

  render() {
    const { minis, customers, error, role } = this.props

    return (
      <div className="machines-admin-view">
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-tablet-alt mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">Minis</span>
              </h1>
            </div>
            {role === 'ADMIN' && (
              <div className="header-actions">
                <Link to="/minis/add" className="mach-admin-btn primary">
                  <i className="fas fa-plus"></i>
                  <span>Nueva Mini</span>
                </Link>
                <button className="mach-admin-btn success" onClick={this.handleMiniDownloadCSV}>
                  <i className="fas fa-file-excel"></i>
                  <span>Descargar Listado</span>
                </button>
              </div>
            )}
          </div>
        </div>
        <MiniList minis={minis}
                  customers={customers}
                  canEdit={role === 'ADMIN'}
                  onSave={this.handleInlineSave} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  minis: state.minis.minis,
  customers: state.customers.customers,
  error: state.minis.error,
  role: state.auth.role,
  fullname: state.auth.fullname
})

const mapDispatchToProps = dispatch => ({
  fetchMinis: bindActionCreators(fetchMinis, dispatch),
  fetchMiniDownloadCSV: bindActionCreators(fetchMiniDownloadCSV, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  updateMini: bindActionCreators(updateMini, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(MinisView)
